import styled from "styled-components";

export const DivForm = styled.div`
  display: flex;
  padding : 22px 0 25px 0;
  flex-direction: column;
  align-content: flex-start;
`;

export const ContainerForm = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-content: flex-start;
`;

export const DivFormInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24vh;
  text-wrap: nowrap;
  border-bottom: 1px solid #1F299C;
  align-content: flex-start;
`;

